<template>
  <div>
    <div class="join join--center">
      <input
        class="checkbox"
        :class="{ 'checkbox--errors': allErrors?.length }"
        type="checkbox"
        v-model="model"
        :disabled="disabled"
      >
      <label class="label label--contents">
        <slot />
      </label>
    </div>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useFieldErrors } from '@shared/lib'

const props = defineProps({
  disabled: Boolean,
  errors: Array,
  name: String,
})

const { fieldErrors, clearFieldErrors } = useFieldErrors(props.name)
const allErrors = computed(() => props.errors ?? fieldErrors.value)

const model = defineModel()
watch(model, () => { if (fieldErrors.value.length) clearFieldErrors() })
</script>
